// src/api/fetchWithAuth.js
import { getToken } from "./auth";

export async function fetchWithAuth(url, options = {}) {
  const token = getToken();
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  // Debug log for token and headers
  console.log('fetchWithAuth:', { url, token, headers });
  return fetch(url, { ...options, headers });
}
